import templateUrl from './app-nav-footer.html';

export const navFooterComponent = {
	templateUrl,

	controller: class NavFooterComponent {
		$onInit() {
			this.currentYear = new Date().getFullYear();
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/app-nav/app-nav-footer.component.js